import axios from "axios";

export function getBranchDropdown(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/account/api/v1/nodes/get-branch-by-country-dropdown`, {
        country: parameters.country,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
